<template>
  <div id="app">
    <router-view v-if="!lock"/>
    <div class="version-lock" v-else>
      <h4>Ваша версия устарела</h4>
      <p>У нас появились критические обновления, пожалуйста обновите приложение до последней версии</p>
    </div>
    <div class="version">{{ VERSION }}</div>
  </div>
</template>

<script>
import firebase from 'firebase';

const VERSION = 2.21;


export default {
  name: 'App',

  data() {
    return {
      init: false,
      lock: false,
      VERSION,
    };
  },

  watch: {
    '$route.params': {
      handler() {
        if (this.$store.state.project.id) {
          this.$router.replace({
            name: this.$route.name,
            params: {
              ...this.$route.params,
            },
            query: {
              ...this.$route.query,
              project: this.$store.state.project.id,
            },
          });
        }
      },
      deep: true,
    },
  },
  beforeCreate() {
    this.$store.dispatch('setUser');
    firebase.firestore()
      .collection('versions')
      .get().then((response) => {
      const result = [];
      response.forEach((d) => result.push(d.data()));
      const version = result[result.length - 1];
      if(version.required && version.updates > VERSION) {
        this.lock = true;
      }
    });
  },
};
</script>

<style lang="scss">
input:disabled {
  color: #000000 !important;
  opacity: 1 !important;
}

textarea:disabled {
  color: #000000 !important;
  opacity: 1 !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.error {
  color: #c0392b;
  text-align: center;
  margin: -5px auto 15px auto;
}

body {
  padding: 0;
  margin: 0;
}

.el-table__row {
  cursor: pointer;
}

.el-checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .el-checkbox__input {
    white-space: normal !important;
  }

  .el-checkbox__label {
    text-align: left;
    white-space: normal !important;
  }
}

.el-dialog {
  width: 50%;
  max-width: 522px;
  @media screen and (max-width: 764px) {
    width: 100% !important;
  }
}

.el-message-box {
  max-width: 420px !important;
  width: 100% !important;

  @media screen and (max-width: 764px) {
    margin-top: 50px !important;
  }
}

.version {
  position: fixed;
  font-size: 12px;
  bottom: 1px;
  right: 4px;
}


::placeholder, .multiselect__placeholder {
  color: #4b5e70 !important;
}

input, textarea, .multiselect__single {
  color: #0e1011 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.multiselect__tag {
  span {
    font-size: 16px !important;
    font-weight: 500 !important;
  }
}

label {
  font-weight: bold !important;
  color: #000 !important;
}

.mx-datepicker-main {
  z-index: 9999 !important;
}

.multiselect__content {
  width: 100% !important;
}

.multiselect__content-wrapper {
  overflow-x: hidden !important;

  .multiselect__option {
    overflow-wrap: anywhere !important;
    white-space: unset !important;
  }
}

.version-lock {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
}

.inline-btn {
  border: none;
  background: rgba(0,0,0,0) !important;
  color: #000;
  display: inline-block;
  width: auto;
  &:hover {
    text-decoration: underline ;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue